import Grid from '@mui/material/Grid';
import is from '@sindresorhus/is';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { AboutMe } from '../../common-section/AboutMe';
import { Ambitions } from '../../common-section/ambitions/Ambitions';
import { GeneralInformation } from '../../common-section/GeneralInformation';
import { Languages } from '../../common-section/languages/Language';
import { Skills } from '../../common-section/Skills';
import { Sidebar } from '../../common-section/sidebar/SideBar';
import { route } from '../../profile-preview/route';

export const GenericPreview: FunctionComponent = () => {
    const {
        applicationState: { locationSearchParams },
    } = useContext(ApplicationContext);

    const userId = locationSearchParams.get(route.searchParams.profilePreviewUserId) ?? '';

    if (is.emptyString(userId)) return null;

    return (
        <Grid columnGap={1} container={true} direction="row">
            <Grid container={true} rowGap={2} size={8} sx={{ pb: 2 }}>
                <GeneralInformation userId={userId} />
                <AboutMe userId={userId} />
                <Skills userId={userId} />
                <Languages userId={userId} />
                <Ambitions userId={userId} />
            </Grid>
            <Grid size="grow">
                <Sidebar userId={userId} />
            </Grid>
        </Grid>
    );
};
